<template>
    <div class="slider_bar">
        <ul>
            <li class="message" @click="messageShow = true">
                <img class="icon" src="@/assets/sliderBar/home_message.png" alt="">
                <span>留言</span>

            </li>
            <li class="wechat">
                <img class="icon" src="@/assets/sliderBar/home_wechat.png" alt="">
                <span>公众号</span>
                <div class="detail">
                    <img :src="showUrl + QRcode" alt="">
                </div>
            </li>
            <li class="phone">
                <img class="icon" src="@/assets/sliderBar/home_phone.png" alt="">
                <span>电话</span>
                <div class="detail">
                    <p class="title">联系电话</p>
                    <p>{{ consultPhone }}</p>
                </div>
            </li>
            <li class="mailbox">
                <img class="icon" src="@/assets/sliderBar/home_mailbox.png" alt="">
                <span>邮箱</span>
                <div class="detail">
                    <p class="title">邮箱</p>
                    <p>{{ email }}</p>
                </div>
            </li>
            <li class="fax">
                <img class="icon" src="@/assets/sliderBar/home_fax.png" alt="">
                <span>传真</span>
                <div class="detail">
                    <p class="title">传真</p>
                    <p>{{ fax }}</p>
                </div>
            </li>
            <li class="top" @click="backTop()">
                <img class="icon" src="@/assets/sliderBar/home_top.png" alt="">
            </li>
        </ul>
        <consulting v-if="messageShow" @close="close" />
    </div>
</template>

<script>
import Consulting from '@/components/consulting.vue'
import { showUrl } from '@/api/api'
export default {
    components: { Consulting },
    data() {
        return {
            messageShow: false,
            consultPhone: '',
            email: '',
            QRcode: '',
            fax:'',
            showUrl
        }
    },
    mounted() {
        this.getBasicSetData()
    },
    methods: {
        backTop() {
            var timer = setInterval(function () {
                let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                let ispeed = Math.floor(-osTop / 5);
                document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                this.isTop = true;
                if (osTop === 0) { clearInterval(timer) }
            }, 20);

        },
        close() {
            this.messageShow = false
        },
        // 获取网站信息
        getBasicSetData() {
            if (localStorage.getItem('basicSet')) {
                let setData = JSON.parse(localStorage.getItem('basicSet'))
                // 二维码
                this.QRcode = setData.qrCodePath
                // 咨询热线
                this.consultPhone = setData.phone
                // 邮箱
                this.email = setData.email
                // 传真
                this.fax = setData.fax
            }
        },
    }
}
</script>

<style lang="less" scoped>
.slider_bar {
    position: fixed;
    // width: 212px;
    height: 280px;
    right: 20px;
    // top: 560px;
    bottom: 100px;
    z-index: 9999;
    ul {
        display: flex;
        flex-direction: column;

        li {
            width: 48px;
            height: 48px;
            font-size: 12px;
            color: #222222;
            background-color: #ffffff;
            box-shadow: -2px 1px 8px 0px rgba(48, 53, 63, 0.1);
            border-radius: 4px;
            margin-bottom: 10px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
            position: relative;
            cursor: pointer;

            &:hover {
                background-color: #0055ff;
                color: #ffffff;

                .detail {
                    display: block;
                }
            }

            .detail {
                display: none;
                position: absolute;
                width: 154px;
                // height: 96px;
                background-color: #ffffff;
                box-shadow: -2px 1px 8px 0px rgba(48, 53, 63, 0.08);
                border-radius: 4px;
                left: -164px;
                top: 0;
                padding: 15px;
                font-size: 14px;
                line-height: 14px;
                color: #666666;

                img {
                    width: 100px;
                    height: 100px;
                    text-align: center;
                }

                p {
                    margin-bottom: 10px;

                    &.title {
                        color: #0055ff;
                    }
                }
            }
        }

        .message:hover {
            .icon {
                content: url('../assets/sliderBar/home_message_checked.png')
            }
        }

        .wechat:hover {
            .icon {
                content: url('../assets/sliderBar/home_wechat_checked.png')
            }
        }

        .phone:hover {
            .icon {
                content: url('../assets/sliderBar/home_phone_checked.png')
            }
        }

        .mailbox:hover {
            .icon {
                content: url('../assets/sliderBar/home_mailbox_checked.png')
            }
        }

        .fax:hover {
            .icon {
                content: url('../assets/sliderBar/home_fax_click.png')
            }
        }

        .top:hover {
            .icon {
                content: url('../assets/sliderBar/home_top_checked.png');
            }
        }
    }
}
</style>